interface Props {
  installed: string;
  useplaceType: string;
}

export const GetStartedBox = ({ useplaceType, installed }: Props) => {
  if (installed !== "installed") return null;

  return (
    <a
      className="text-gray-800 hover:underline"
      href={`/kundservice/kom-igang/${
        useplaceType === "house" ? "villa" : "lagenhet"
      }`}
    >
      <div className="uppercase text-xs">
        Nyss flyttat in eller blivit ansluten
      </div>
      <div>
        Tjänsteleverantörerna i stadsnätet erbjuder tjänster inom internet, TV
        och telefoni. Här kan du läsa mer om vilka som finns och hur du kommer
        igång med tjänsterna.
      </div>
    </a>
  );
};
